import type {
  StepCustomerData,
  StepMphData,
  StepOrdererData,
  StepOrderRequestData,
  StepOwnerData,
  StepProductData,
} from './step-data';

export interface Step {
  name: string;
  icon: string;
  title: string;
  sequence: number;
  isCompleted: boolean;
  isDisabled: boolean;
  isActive: boolean;
  component: unknown;
}

export enum BookingMode {
  houseConnectionOnly,
  houseConnectionAndNe4,
  productOnly, // Common case for a single product
  productOnlyMph, // Also a single product, but within MPH context
  houseConnectionAndProduct,
  ne4AndProduct,
  ne4Only,
  houseConnectionAndNe4AndProduct,
}

export type UpdateFinishButtonFunc = (text: string, disabled: boolean) => void;

export type BookingModeFunc = (mode: BookingMode) => void;

export interface BookingModeSteps {
  availableSteps: string[];
  name: BookingMode;
}

export interface Order {
  confirmedByBackOffice: boolean;
  eeccOrderId: string | null;
  externalOrderNumber: string | null;
  hasHouseConnection: boolean;
  hasMph: boolean;
  hasProduct: boolean;
  houseConnectionDocumentName: string | null;
  isD2dConfirmed: boolean;
  isEeccRelevant: boolean;
  orderingType: string;
  productDocumentName: string | null;
  stepCustomerData: StepCustomerData | null;
  stepMphData: StepMphData | null;
  stepOrdererData: StepOrdererData | null;
  stepOrderRequestData: StepOrderRequestData | null;
  stepOwnerData: StepOwnerData | null;
  stepProductData: StepProductData | null;
  userId: number;
  channel: string;
  customerId: number | null;
}
